<div class="show-more-section" [ngClass]="{collapsed: !expanded && contentTooLong}">
  <div style="margin-bottom: 20px;">
    <ng-content/>
  </div>
  @if (contentTooLong && !expanded) {
    <a (click)="expanded=true;" class="expand-trigger">See more...</a>
  }
  @if (contentTooLong && expanded) {
    <a (click)="expanded=false;" class="expand-trigger">See less...</a>
  }
</div>
